<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead style="background: #425058;">
          <tr>
            <th style="color: #fff;">Name</th>
            <th style="color: #fff;">Code</th>
            <th style="color: #fff;">Is Price Source?</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="source in priceSources" :key="source.codeName" @click="addPriceSource(source.code)">
            <td>{{ source.name }}</td>
            <td>{{ source.code }}</td>
            <td>{{ source.isPriceSource }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    priceSources: Array,
    setPriceSource: Function
  },
  methods: {
    addPriceSource (priceSource) {
      this.setPriceSource(priceSource)
    }
  }
}
</script>
